<template>
  <el-dialog
    :visible.sync="visible"
    title=""
    class="dialog"
    width="500px"
    :close-on-click-modal="false"
  >
    <template v-if="canRefundAll">
      <el-descriptions :column="1" size="medium">
        <el-descriptions-item label="预存账户余额">
          {{ guaranteePreSave.useTotalAmount }}
        </el-descriptions-item>
        <el-descriptions-item label="退款金额">
          {{ guaranteePreSave.remainTotalAmount }}
        </el-descriptions-item>
      </el-descriptions>
      <div>按照打款记录原路退回</div>
    </template>
    <template v-else>
      <div>
        当前占用额度为：{{
          guaranteePreSave.consumeTotalAmount
        }}元，不支持全部退款；
      </div>
      <div>
        请选择打款记录部分退款，项目结束解除占用后，再退款占用额度的金额。
      </div>
    </template>
    <template v-slot:footer>
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { batchApplyGuaranteePreSaveRefundApi } from '@/api/guarantee-pre-save'

export default {
  name: 'GuaranteePreSaveRefundAllDialog',

  data() {
    return {
      visible: false,
      canRefundAll: false
    }
  },

  computed: {
    ...mapState('finance', ['guaranteePreSave'])
  },

  methods: {
    openDialog(bool) {
      this.visible = true
      this.canRefundAll = bool
    },

    onCancel() {
      this.visible = false
    },

    onConfirm() {
      if (this.canRefundAll) {
        batchApplyGuaranteePreSaveRefundApi()
          .then(res => {
            this.$emit('refundAll')
            this.onCancel()
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      } else {
        this.onCancel()
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
